import { getTranslation } from '../helpers/utilities';
import { h } from 'preact';

const CartEmpty = () => {
  return (
    <div class="my-4 rte">
      <p>{getTranslation('cart.empty')}</p>
      <p
        dangerouslySetInnerHTML={{
          __html: getTranslation('cart.keep_shopping_html'),
        }}
      />
    </div>
  );
};

export default CartEmpty;
